import { useQuery } from "@tanstack/react-query";
import { refetchApiInterval } from "../../shared/constants";
import { searchAssets } from "../api/assets-v2.service";
export const useSearchAssetsQuery = ({ enabled = true, paramsList, requestBody }) => {
    return useQuery({
        enabled,
        gcTime: 0,
        queryFn: () => {
            return searchAssets(requestBody, paramsList);
        },
        queryKey: ["searchAssets", requestBody, paramsList],
        refetchInterval: refetchApiInterval,
        retry: 0
    });
};
